import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 5h13c.55 0 1 .45 1 1v.43l-7.5 4-7.5-4V6c0-.55.45-1 1-1zm13 10H3c-.55 0-1-.45-1-1V7.57l7.26 3.87c.07.04.15.06.24.06s.16-.02.24-.06L17 7.57V14c0 .55-.45 1-1 1z',
  ],
  height: 20,
  width: 20,
});
